import React, { useState } from 'react'
import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from '@material-ui/core'
import {
  ArrowUp as ArrowUpIcon,
  StopCircle as StopCircleIcon,
} from 'react-feather'
import clsx from 'clsx'

import { SendFeedbackModal } from './components'

import useDaiChat from 'hooks/useDaiChat'

import useStyles from './styles'
import useWaitingText from 'hooks/useWaitingText'

const ChatActions = ({ minRows = 1, placeholder = 'Pergunte para DAI...' }) => {
  const [feedbackSent, setFeedbackSent] = useState(false)
  const [openFeedbackModal, setOpenFeedbackModal] = useState(false)

  const classes = useStyles()

  const {
    abortMessage,
    daiChat,
    hasMessage,
    inputMessage,
    inputRef,
    isSending,
    messages,
    registerMixpanelEvent,
    sendMessage,
    setInputMessage,
  } = useDaiChat()

  const waitText = useWaitingText({ active: true })

  const handleClickPolicy = () => {
    registerMixpanelEvent('click-policy')
  }

  const handleOpenFeedbackModal = () => {
    registerMixpanelEvent('open-feedback')
    setOpenFeedbackModal(true)
  }

  return (
    <Box>
      <Box mb={1}>
        <TextField
          className={classes.input}
          inputRef={inputRef}
          variant="outlined"
          placeholder={isSending ? waitText : placeholder}
          size="small"
          fullWidth
          multiline
          minRows={minRows}
          maxRows={7}
          inputProps={{ readOnly: isSending }}
          onChange={(e) => setInputMessage(e.target.value)}
          value={inputMessage}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey && !isSending) {
              e.preventDefault()
              sendMessage()
            }
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {isSending ? (
                  <IconButton
                    aria-label="parar geração"
                    size="small"
                    className={classes.stopButton}
                    onClick={abortMessage}
                  >
                    <StopCircleIcon size={20} />
                  </IconButton>
                ) : (
                  <Button
                    aria-label="enviar mensagem"
                    size="small"
                    onClick={() => sendMessage()}
                    color="primary"
                    variant="contained"
                    className={classes.sendIcon}
                    disabled={!inputMessage}
                  >
                    <ArrowUpIcon size={20} />
                  </Button>
                )}
              </InputAdornment>
            ),
          }}
        />
      </Box>

      {!hasMessage && (
        <Typography variant="body2" color="textSecondary" align="center">
          A <strong>DAI (DPO Artificial Intelligence)</strong> ainda está em
          fase de testes e pode cometer erros. Por isso, cheque as
          respostas.&nbsp;
          <strong>
            <a
              onClick={handleClickPolicy}
              href="https://www.dponet.com.br/politica-de-uso-etico-de-inteligencia-artificial-da-dponet/"
              target="_blank"
              rel="noopener noreferrer"
              className={classes.linkColor}
            >
              Clique aqui
            </a>
          </strong>
          &nbsp;para consultar nossa Política de Uso Ético de IA.
        </Typography>
      )}

      {!!daiChat?.sessionId && messages.length > 2 && !feedbackSent && (
        <Typography variant="body2" color="textSecondary" align="center">
          A DAI te ajudou?&nbsp;
          <strong>
            <button
              onClick={handleOpenFeedbackModal}
              className={clsx(classes.feedbackLink, classes.linkColor)}
            >
              Enviar feedback
            </button>
          </strong>
          .
        </Typography>
      )}

      <SendFeedbackModal
        open={openFeedbackModal}
        setOpen={setOpenFeedbackModal}
        onSuccess={() => setFeedbackSent(true)}
        daiChat={daiChat}
      />
    </Box>
  )
}

export default ChatActions
